"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentRelationType = void 0;
var DocumentRelationType;
(function (DocumentRelationType) {
    DocumentRelationType[DocumentRelationType["LeadServiceLine"] = 0] = "LeadServiceLine";
    DocumentRelationType[DocumentRelationType["Location"] = 1] = "Location";
    DocumentRelationType[DocumentRelationType["Facility"] = 2] = "Facility";
    DocumentRelationType[DocumentRelationType["District"] = 3] = "District";
    DocumentRelationType[DocumentRelationType["Fixture"] = 4] = "Fixture";
    DocumentRelationType[DocumentRelationType["CommunicationDeprecated"] = 5] = "CommunicationDeprecated";
    DocumentRelationType[DocumentRelationType["LetterArchive"] = 6] = "LetterArchive";
    DocumentRelationType[DocumentRelationType["ReportInstance"] = 7] = "ReportInstance";
    DocumentRelationType[DocumentRelationType["CommunicationTemplate"] = 8] = "CommunicationTemplate";
    DocumentRelationType[DocumentRelationType["Communication"] = 9] = "Communication";
    DocumentRelationType[DocumentRelationType["CommunicationSnippet"] = 10] = "CommunicationSnippet";
    DocumentRelationType[DocumentRelationType["LetterBatch"] = 11] = "LetterBatch";
    DocumentRelationType[DocumentRelationType["ServiceLine"] = 12] = "ServiceLine";
})(DocumentRelationType = exports.DocumentRelationType || (exports.DocumentRelationType = {}));
//# sourceMappingURL=DocumentRelationType.js.map